import { Button } from "@/components/ui/button";
import ScheduleDemo from "@/features/onboarding/login/Schedule-demo";
import { useMemo } from "react";
import lockedContentIcon from "@/assets/newOnboardning/locked-content@2x.webp";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
} from "@/components/ui/dialog";
import { useNavigate } from "react-router-dom";
import noPlan from "@/assets/no-plans.svg"

interface AuthErrorPageProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

export default function AccessRight({ open, onOpenChange }: AuthErrorPageProps) {
  const { isOrgAdmin } = useMemo(() => {
    const user = JSON.parse(localStorage.getItem("user") + "");
    return {
      isOrgAdmin: user?.accessRights?.isOrgAdmin === true,
    };
  }, []);
  const navigate = useNavigate();

  return (
    <Dialog  open={open} onOpenChange={onOpenChange} >
<DialogContent className="max-w-xl p-0 z-[50]">
  <div className="flex flex-col items-center text-center bg-white p-8 rounded-lg shadow-lg w-full">
    <div className="mb-6 flex justify-center items-center">
      {isOrgAdmin ? (
        <img
          src={lockedContentIcon}
          alt=""
          className="w-[300px] h-[194px]"
        />
      ) : (
        <img
          src={noPlan}
          alt=""
          className="w-[300px] h-[194px]"
        />
      )}
    </div>

    <DialogHeader>
      <DialogTitle className="text-2xl font-bold text-[#181818]">
        {isOrgAdmin ? (
          <>
            You Currently Have{" "}
            <span className="text-[#28af4a]">Limited Access</span>
          </>
        ) : (
          "Get Access to This Feature"
        )}
      </DialogTitle>
    </DialogHeader>

    <DialogDescription className="text-gray-700 my-4 max-w-md">
      {isOrgAdmin ? (
        "Your current subscription doesn’t give you access to this module. Upgrade your plan to unlock full access to advanced features and tools designed to help you win more leads and close more deals."
      ) :(
        "It looks like you don't have access to this module. To unlock access, please get in touch with the administrator."
      )}
    </DialogDescription>

      {isOrgAdmin ? (
        <Button
        onClick={() => navigate("/profile/subscription")}
        className="bg-green-500 px-6 hover:bg-green-600">
          Upgrade Now
        </Button>
      ) : (
        <ScheduleDemo forceOpenOnClick={true}>
          <Button className="bg-green-500 px-6 hover:bg-green-600">
            Contact Administrator
          </Button>
        </ScheduleDemo>
      )}
  </div>
</DialogContent>


    </Dialog>
  );
}
